<template>
    <div class="terms-content">
        <p>
            By using Enact, you are agreeing to the terms stated here:
            <a href="https://delta.lcp.com/technology-products-standard-terms/" target="_blank" rel="noopener noreferrer">
                LCP Delta technology products standard terms
            </a>
        </p>
        <div>
            <h3>LCP Enact Authorised User Confirmation</h3>
            <p>
                You acknowledge and agree: (a) that these Terms and Conditions (including, without limitation, the exclusions and limitations of liability in Sections 6, 8
                and 9) are fair, reasonable and necessary for LCP in the protection of its Confidential Information, intellectual property rights and its business; (b)
                having reviewed these Terms and Conditions, that there is nothing which would breach, or cause the breach of, or would conflict with any other terms
                (including, without limitation, terms of employment) to which you may be subject; (c) your entering into discussions with LCP, and your furnishing
                information/content (if applicable), shall not infringe the intellectual property rights of any third party; and (d) that the Licence granted by LCP is the
                sole benefit and/or advantage that may arise to you under these Terms and Conditions and any other benefits and/or advantages (which by operation of law or
                otherwise) may arise are hereby disclaimed and waived.
            </p>
        </div>
    </div>
</template>

<script lang="ts" setup>
</script>

<style lang="scss" scoped>
.terms-content {
    display: flex;
    flex-direction: column;
    padding: var(--largeSpacing);
    gap: var(--largeSpacing);
    overflow: auto;
}
h3 {
    margin: var(--defaultSpacing) 0;
    font-weight: bold;
}
</style>
